// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"06abfc1b","376":"865a4a2e","622":"bf493d39","896":"ea4f3aa3"}[chunkId] + ".chunk.css";
};